module.exports = __webpack_public_path__ + "static/media/Senate-2.bf38a759.pdf";